import { render, staticRenderFns } from "./viewWorks.vue?vue&type=template&id=7dd5ce3e"
import script from "./viewWorks.vue?vue&type=script&lang=js"
export * from "./viewWorks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7dd5ce3e')) {
      api.createRecord('7dd5ce3e', component.options)
    } else {
      api.reload('7dd5ce3e', component.options)
    }
    module.hot.accept("./viewWorks.vue?vue&type=template&id=7dd5ce3e", function () {
      api.rerender('7dd5ce3e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/backstage/player/viewWorks.vue"
export default component.exports